import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Startup file for the MCE visual editor to create the shortcode modal.
 *
 * @module rml_shortcode
 */
import tinymce from "tinymce";
import rmlOpts from "rmlopts";
import { request, hooks } from "./util";
var TAG = "folder-gallery";
/**
 * This function is fired, when the dialog button "OK" gets pressed.
 *
 * @this tinymce.Editor instance
 */

function submit(_ref) {
  var data = _ref.data;

  if (!data) {
    return;
  }

  var fid = data.fid,
      link = data.link,
      columns = data.columns,
      orderby = data.orderby,
      size = data.size;

  if (fid > -1) {
    var shortcode = "[".concat(TAG, " fid=\"").concat(fid, "\"");
    link && link !== "post" && (shortcode += " link=\"".concat(link, "\""));
    columns && +columns !== 3 && (shortcode += " columns=\"".concat(columns, "\""));

    if (orderby === true) {
      shortcode += " orderby=\"rand\"";
    } else {
      shortcode += " orderby=\"rml\"";
    }

    size && size !== "thumbnail" && (shortcode += " size=\"".concat(size, "\""));
    var sdata = {
      shortcode: shortcode
    };
    /**
     * The shortcode gets generated. You are able to modify the shortcut
     * depending on the modal data.
     *
     * @event module:util/hooks#shortcode/dialog/insert
     * @param {object} shortcodeData
     * @param {object} shortcodeData.shortcode The shortcode which you can modify
     * @param {object} data The data from the dialog
     */

    hooks.call("shortcode/dialog/insert", [sdata, data], this);
    sdata.shortcode += "]";
    this.insertContent(sdata.shortcode);
  }
}

tinymce.PluginManager.add(TAG, function (editor) {
  // Command
  editor.addCommand("folder_gallery_popup", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ui, v) {
      var _yield$request, _yield$request$slugs, names, slugs, types, listValues, _ref3, _ref3$fid, fid, _ref3$link, link, _ref3$columns, columns, _ref3$orderby, orderby, _ref3$size, size, columnsValue, mce, options;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Create tree for listbox
              editor.setProgressState(true);
              _context.next = 3;
              return request({
                location: {
                  path: "/tree"
                }
              });

            case 3:
              _yield$request = _context.sent;
              _yield$request$slugs = _yield$request.slugs;
              names = _yield$request$slugs.names;
              slugs = _yield$request$slugs.slugs;
              types = _yield$request$slugs.types;
              names.shift();
              slugs.shift();
              types.shift();
              listValues = slugs.map(function (id, i) {
                return {
                  text: names[i],
                  value: id,
                  disabled: [1].indexOf(types[i]) > -1
                };
              });
              editor.setProgressState(false); // Prepare dialog

              _ref3 = v || {}, _ref3$fid = _ref3.fid, fid = _ref3$fid === void 0 ? "" : _ref3$fid, _ref3$link = _ref3.link, link = _ref3$link === void 0 ? "" : _ref3$link, _ref3$columns = _ref3.columns, columns = _ref3$columns === void 0 ? "3" : _ref3$columns, _ref3$orderby = _ref3.orderby, orderby = _ref3$orderby === void 0 ? "" : _ref3$orderby, _ref3$size = _ref3.size, size = _ref3$size === void 0 ? "" : _ref3$size, columnsValue = [1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (i) {
                return {
                  text: "" + i,
                  value: "" + i
                };
              }), mce = rmlOpts.others.mce; // Show dialog

              options = {
                title: mce.mceButtonTooltip,
                onsubmit: submit.bind(editor),
                body: [{
                  // Add folder select
                  type: "listbox",
                  name: "fid",
                  label: mce.mceBodyGallery,
                  value: fid,
                  values: listValues,
                  tooltip: mce.mceListBoxDirsTooltip
                }, {
                  // Add link to select
                  type: "listbox",
                  name: "link",
                  label: mce.mceBodyLinkTo,
                  value: link,
                  values: mce.mceBodyLinkToValues
                }, {
                  // Add columns (1-9) to select
                  type: "listbox",
                  name: "columns",
                  label: mce.mceBodyColumns,
                  value: columns,
                  values: columnsValue
                }, {
                  // Add random order checkbox
                  type: "checkbox",
                  name: "orderby",
                  label: mce.mceBodyRandomOrder,
                  value: orderby
                }, {
                  // Add size to select
                  type: "listbox",
                  name: "size",
                  label: mce.mceBodySize,
                  value: size,
                  values: mce.mceBodySizeValues
                }]
              };
              /**
               * The shortcode dialog gets opened. You can modify the fields.
               *
               * @event module:util/hooks#shortcode/dialog/open
               * @param {object} options The options
               * @param {object} editor The editor instance
               */

              hooks.call("shortcode/dialog/open", [options, editor]);
              editor.windowManager.open(options);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()); // Add tinymce button

  rmlOpts && editor.addButton(TAG, {
    icon: " rmlicon-gallery",
    tooltip: rmlOpts.others.mce.mceButtonTooltip,
    cmd: "folder_gallery_popup"
  });
});